module.exports = __webpack_public_path__ + "img/tombstone.221d366d.png";